import LazyLoad from "react-lazyload";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
const VisualArts = () => {
  const homeMenu = [
    {
      label: "Curriculum",
      link: "",
      subMenu: [
        { label: "Primary Wing", link: "/primarywing" },
        { label: "Middle Wing", link: "/middleWing" },
        { label: "Senior Wing", link: "/seniorWing" },
        { label: "Curriculum", link: "/curriculum" },
      ],
    },

    {
      label: "Extended Classroom",
      link: "",
      subMenu: [
        { label: "Labs", link: "/mathmatics" },
        { label: "Excursions", link: "/excursions" },
        { label: "Library", link: "/library" },
        { label: "Field Trips", link: "/feildTrip" },
        { label: "Astronomy", link: "/astronomy" },
      ],
    },
    {
      label: "Sports",
      link: "",
      subMenu: [
        { label: "Sports", link: "/sports" },
        {
          label: "Achievements in Sports 2022-23",
          link: "/acheivementInSports",
        },
      ],
    },
    {
      label: "Arts",
      link: "",
      subMenu: [
        { label: "Performing Arts", link: "/music" },
        { label: "Visual Arts", link: "/visualArts" },
      ],
    },

    { label: "Houses", link: "/houses" },
    { label: "Assembly", link: "/assembly" },
    { label: "Book List", link: "/booklist" },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/banner-house.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Houses"
                breadEnd="Learning Approach"
                breadMid="Houses"
              />
            </div>
          </div>
          <div className="row ">
            <div className="col-xl-12 mb-4">
              <p>
                Lotus Valley International School, Gurgaon, has a House System
                to promote a spirit of community, friendship, teamwork and
                healthy competition amongst the learners.
              </p>
              <p>
                House System develops a sense of pride in the school, fosters
                school culture and accentuates learners’ acumen in an array of
                sports and cultural activities. The Four Houses in the school
                are
              </p>
              <div className="house-flex d-flex">
                <div className="green-house">Gandhi House</div>
                <div className="red-house">Nehru House </div>
                <div className="yellow-house">Tagore House </div>
                <div className="blue-house">Teresa House</div>
              </div>

              <LazyLoad>
                {" "}
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/house1.jpg"
                  className="float-end wid-500 m-2"
                  alt="Lotus Valley Gurgaon"
                />
              </LazyLoad>
              <p>
                Each House is supervised by a House Warden and a team of
                dedicated House Teachers. The House is ably led by a House
                Captain and House Vice- Captain.
              </p>
              <p>
                Throughout the year, various co-curricular and extra-curricular
                Inter-House contests are organized in which learners of all
                Houses participate. These include English and Vernacular
                Elocution, Quiz Contests, Rangoli making, PPT making, to name a
                few. These activities hone the learners’ skills, sharpen their
                intellect, nurture hobbies, relax their mind and thereby promote
                the holistic growth of the learners.
              </p>
              <p>
                Based on year round performance in diverse activities of the
                academic year, the best performing House is declared the
                ‘Champion’.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default VisualArts;
